import { Injectable } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import {
  BasePageMetaResolver,
  PageRobotsResolver,
  PageType,
  TranslationService,
  BreadcrumbMeta,
} from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { KbCheckOutService } from '../../services/feature/CheckOut/kb-check-out.service';
import { map, mergeMap } from 'rxjs/operators';
import { checkOutConfig } from 'src/app/customcomponents/kb-Checkout/checkout.config';
import { CheckoutPageMetaResolver } from '@spartacus/checkout/base/core';

@Injectable({
  providedIn: 'root',
})
export class KbCheckoutPageMetaResolver extends CheckoutPageMetaResolver implements PageRobotsResolver {
  constructor(
    protected override translationService: TranslationService,
    protected override activeCartFacade: ActiveCartFacade,
    protected override basePageMetaResolver: BasePageMetaResolver,
    protected kbCheckoutService: KbCheckOutService
  ) {
    super(translationService, activeCartFacade, basePageMetaResolver);
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'MultiStepCheckoutSummaryPageTemplate';
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | any[] | undefined> {
    return combineLatest([
      this.kbCheckoutService.activeStep,
      this.translationService.translate('common.breadcrumb_home'),
      this.translationService.translate('common.checkout_multi_breadcrumb'),
    ]).pipe(
      mergeMap(([stepIndex, homeLabel, checkoutLabel]) => {
        if (stepIndex > 0) {
          return this.translationService.translate(checkOutConfig[stepIndex - 1].breadCrumbTitle).pipe(
            map((stepLabel) => {
              const breadcrumbs: BreadcrumbMeta[] = [];
              breadcrumbs.push({ label: homeLabel, link: '/' });
              breadcrumbs.push({ label: checkoutLabel, link: '' });
              breadcrumbs.push({ label: stepLabel.toUpperCase(), link: '' });
              return breadcrumbs;
            })
          );
        } else {
          return this.basePageMetaResolver.resolveBreadcrumbs();
        }
      })
    );
  }
}
